module.exports = __webpack_public_path__ + "Lato-Bold.44dfe8cc676882243911";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-Bold.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Bold.ttf
// module chunks = styles